/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack } from 'react-bootstrap'
import { StepProps, feesTextField, feesRadioField } from '../IAppModels'
import { FeesTextInput } from './stepComponents/FeesTextInput'
import { FeesRadioInput } from './stepComponents/FeesRadioInput'

const Step3 = ({ data, updateData, hasError, setHasError }: StepProps) => {
  return (
    <>
      {/*begin::Step 3 */}
      <div data-kt-stepper-element='content'>
        <div
          className='w-100 overflow-auto pe-7'
          style={{ height: '435px' }}
        >
          {/*Step heading*/}
          <h3>Pricing Setup</h3>

          {/* begin:: Fee setup */}
          <div className='row mt-3'>
            {feesTextField.map((fee: any) => (
              <FeesTextInput
                fieldName={fee.name}
                fieldLabel={fee.label}
                data={data}
                updateData={updateData}
                hasError={hasError}
              />
            ))}
          </div>
          {/* end:: Fee setup */}

          {/* begin:: Credit radio button*/}
          <div style={{ marginTop: '45px' }}>
            <Stack direction='horizontal' gap={5}>
              {feesRadioField.map((fee: any) => (
                <FeesRadioInput
                  fieldName={fee.name}
                  fieldLabel={fee.label}
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                />
              ))}
            </Stack>
          </div>
          {/* end:: Credit radio button*/}

          {/* begin:: Credit Amount field*/}
          <div className='mt-5'>
            <FeesTextInput
              fieldName='creditAmount'
              fieldLabel='Credit Amount'
              data={data}
              updateData={updateData}
              hasError={hasError}
            />
          </div>
          {/* end:: Credit Amount field*/}
        </div>
      </div>
      {/*end::Step 3 */}
    </>
  )
}

export { Step3 }
